<template>
  <div>
    <div class="cardLayoutWrapper">
      <div class="elem elem--span-2"></div>
      <div class="elem elem--span-4 elem--clickable">
        <span @click="useRechercheVirementActions().displayVirement(item.code)">{{ item?.reference }}</span>
      </div>
      <div class="elem elem--span-5">{{ dateTimeToReadableDate(item?.dateEmission) }}</div>
      <div class="elem elem--span-5 elem--nowrap">
        <span>{{ `${formatNumber(item?.montantTTC, { decimal: 2, separateur: true })} €` }}</span>
      </div>
      <div class="elem elem--span-7 elem--nowrap">
        <span>{{ item?.denominationBeneficiaire }}</span>
      </div>
      <div class="elem elem--span-5 elem--nowrap">
        <span>{{ item?.codeFacture }}</span>
      </div>
      <div class="elem elem--span-5 elem--nowrap">
        <span>{{ item?.codeDossier }}</span>
      </div>
      <div class="elem elem--span-1 elem--clickable">
        <BasicTooltip label="Consulter la facture">
          <BasicIcon
            @click="useRechercheVirementActions().displayVirement(item.code)"
            name="eye"
            :active="false"
          />
        </BasicTooltip>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { VirementDTO } from '@/features/api/extranet/dto/Virement'
  import { dateTimeToReadableDate } from '@/features/shared/tools/date'
  import { formatNumber } from '@/features/shared/tools'
  import { useRechercheVirementActions } from '../useRechercheVirementActions'

  defineProps<{ item: VirementDTO }>()
</script>

<style scoped>
  @import '../../index.less';
</style>
